import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { isEmpty } from "@swiggy-private/core-ui";

export const BannerContainer = styled.div<{ isSlaCommsTextPresent: boolean }>`
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: ${({ theme }) => theme.cornerRadius.medium};
`;

export const DeliveryTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: 100%;
    width: 100%;

    position: absolute;
    top: calc(${({ theme }) => theme.spacing.xxSmall} * -1);
    left: ${({ theme }) => theme.spacing.large};
`;

export const DeliveryTextBody = styled(Text)`
    // inline image should be aligned with the text
    img {
        vertical-align: sub;
        margin-bottom: 1px;
    }

    // inline span should be bold text
    span {
        display: inline-block;
        color: ${({ theme }) => theme.colors[theme.colorMode].primary};

        // need to extend from the typography to make it bold
        ${({ theme }) => {
            return { ...theme.typography["V2.body1.neutral.bold"] };
        }};
    }
`;

export const DeliveryImage = styled.div<{ imgContainerHeight: string; imgContainerWidth: string }>`
    display: flex;
    align-items: end;
    justify-content: end;

    // inline image should be aligned with the spec for the height and width
    div {
        height: ${({ imgContainerHeight }) => (!isEmpty(imgContainerHeight) ? imgContainerHeight : "auto")};
        width: ${({ imgContainerWidth }) => (!isEmpty(imgContainerWidth) ? imgContainerWidth : "auto")};
    }
`;
